import React from "react";
import { Button } from "primereact/button";

type PaginatorWithoutTotalCountProps = {
  page: number;
  rows: number | undefined;
  maxRows: number;
  setPage: (page: number) => void;
};

const PaginatorWithoutTotalCount = ({ page, setPage, rows, maxRows }: PaginatorWithoutTotalCountProps) => {
  return (
    <div className="flex justify-content-center align-items-center gap-3 pb-2">
      <Button
        icon="pi pi-angle-left"
        className="p-button-rounded p-button-text p-button-plain"
        onClick={() => setPage(page - 1)}
        disabled={page < 1}
      />

      {page + 1}

      <Button
        icon="pi pi-angle-right"
        className="p-button-rounded p-button-text p-button-plain"
        onClick={() => setPage(page + 1)}
        disabled={rows !== maxRows}
      />
    </div>
  );
};

export default PaginatorWithoutTotalCount;
